import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/assets/img/pdf/newvation/newvation-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d1ad47d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-background w-screen h-screen" }
const _hoisted_2 = { class: "flex flex-col justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pageHeader" }, "Übersicht"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon",
      src: _imports_0,
      width: "50",
      style: {"margin-top":"-12px","padding-bottom":"10px"}
    })
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner-m" }, null, -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "title-container stackpanel" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-4xl midHeader" }, " Allgemein - Mast ", -1))
const _hoisted_8 = { class: "flex mt-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Mastnummer:", -1))
const _hoisted_10 = {
  class: "w-60",
  "data-cy": "pdf-pole-nr"
}
const _hoisted_11 = { class: "flex mt-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Leitungsanlage:", -1))
const _hoisted_13 = {
  class: "w-60",
  "data-cy": "pdf-leitungsanlage"
}
const _hoisted_14 = { class: "flex mt-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Anzahl der Meldungen:", -1))
const _hoisted_16 = {
  class: "w-60",
  "data-cy": "pdf-reports-number"
}
const _hoisted_17 = { class: "mast-view flex w-70 mr-5" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner" }, null, -1))
const _hoisted_20 = {
  class: "title-container",
  style: {"width":"100%","margin-right":"10px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-4xl midHeader" }, " Schäden - Zusammenfassung ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Status - Schaden"),
    /*#__PURE__*/_createElementVNode("th", null, "Schwere - Schaden"),
    /*#__PURE__*/_createElementVNode("th", null, "Beschreibung - Meldung")
  ])
], -1))
const _hoisted_23 = { style: {"width":"12%"} }
const _hoisted_24 = {
  key: 0,
  style: {"width":"17%"}
}
const _hoisted_25 = {
  key: 1,
  style: {"width":"17%"}
}
const _hoisted_26 = {
  key: 2,
  style: {"width":"20%"}
}
const _hoisted_27 = {
  key: 3,
  style: {"width":"15%"}
}
const _hoisted_28 = { style: {"width":"36%","max-width":"36%"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner" }, null, -1))
const _hoisted_30 = { class: "title-container stackpanel" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-4xl midHeader" }, " Bericht - Zusammenfassung ", -1))
const _hoisted_32 = { class: "flex mt-1" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Gutachter:", -1))
const _hoisted_34 = {
  class: "w-80",
  "data-cy": "pdf-report-gutachter"
}
const _hoisted_35 = { class: "flex mt-1" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Datum der Dokumentation:", -1))
const _hoisted_37 = {
  class: "w-60",
  "data-cy": "pdf-sighting-date"
}
const _hoisted_38 = { class: "flex mt-1" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Datum der Reperatur - geplant:", -1))
const _hoisted_40 = {
  class: "w-60",
  "data-cy": "pdf-action-planned"
}
const _hoisted_41 = { class: "flex mt-1" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Letztes Update:", -1))
const _hoisted_43 = {
  class: "w-80",
  "data-cy": "pdf-report-update"
}
const _hoisted_44 = { class: "flex mt-1" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Fazit:", -1))
const _hoisted_46 = {
  class: "w-80 textBlock",
  "data-cy": "pdf-report-conclusion"
}
const _hoisted_47 = { class: "flex mt-1" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Status:", -1))
const _hoisted_49 = {
  class: "w-80",
  "data-cy": "pdf-report-status"
}
const _hoisted_50 = { class: "flex mt-1" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Bearbeiter:", -1))
const _hoisted_52 = {
  class: "w-80",
  "data-cy": "pdf-report-worker"
}
const _hoisted_53 = { class: "flex mt-1" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Unterschriften:", -1))
const _hoisted_55 = { class: "w-80" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = ["src", "alt"]
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "report-background w-screen h-screen" }
const _hoisted_60 = { class: "flex flex-col justify-between" }
const _hoisted_61 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_page_bottom = _resolveComponent("page-bottom")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_page_header, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            title: 'Übersicht'
          }, null, 8, ["ba", "immobilie"]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.ba.fragenblocks?.[0].fragenblocks?.[0].frages?.[0].eingabeText), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.ba.fragenblocks?.[0].fragenblocks?.[0].frages?.[1].eingabeText), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.ba.fragenblocks?.[0].fragenblocks?.[0].frages?.[2].eingabeText), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("img", {
                    src: _ctx.getPhotoUrl(_ctx.immobilie?.vorschaubild),
                    style: {"max-height":"100px","max-width":"100px"},
                    "data-cy": "generalData-vorschaubild"
                  }, null, 8, _hoisted_18)
                ])
              ]),
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("table", null, [
                  _hoisted_22,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meldungen.filter((_, idx) => idx != 0), (meldung, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_23, _toDisplayString("Schaden " + (index + 1)), 1),
                        (meldung.frages?.[6].eingabeBoolean == true)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_24, " Behoben "))
                          : (_openBlock(), _createElementBlock("td", _hoisted_25, " Nicht Behoben ")),
                        (meldung.frages?.[4].eingabeAuswahlWert != undefined)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(meldung.frages?.[4].eingabeAuswahlWert), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_27, " - ")),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(meldung.frages?.[2]?.eingabeText
                        ?.match(/.{1,50}/g)
                        ?.join('\n')), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", null, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.ba.gutachter.username), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.moment(_ctx.ba.sichtungsdatum).isValid() ? _ctx.moment(_ctx.ba.sichtungsdatum).format("DD.MM.YYYY") : '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.moment(_ctx.ba.begehungsdatum).isValid() ? _ctx.moment(_ctx.ba.begehungsdatum).format("DD.MM.YYYY") : '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.moment(_ctx.ba.updatedAt).isValid() ? _ctx.moment(_ctx.ba.updatedAt).format("DD.MM.YYYY") : '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.ba.fazit), 1)
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.statusReadable), 1)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.ba.bearbeitenderNutzer?.username), 1)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("span", _hoisted_55, [
                      (_ctx.ba.unterschrifts && _ctx.ba.unterschrifts.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ba.unterschrifts.slice(0,3), (unterschrift, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                style: {"margin-bottom":"10px"}
                              }, [
                                (unterschrift.bild)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _ctx.getPhotoUrl(unterschrift.bild),
                                      style: {"max-height":"200px","max-width":"200px"},
                                      alt: 'Unterschrift ' + (index + 1),
                                      "data-cy": "singatures"
                                    }, null, 8, _hoisted_57))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", null, _toDisplayString(unterschrift.name), 1)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_58, " Keine Unterschriften "))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(_component_page_bottom)
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_page_header, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            title: 'Immobilie Vorschaubild'
          }, null, 8, ["ba", "immobilie"]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("img", {
              src: _ctx.getPhotoUrl(_ctx.immobilie?.vorschaubild),
              "data-cy": "generalData-vorschaubild",
              style: {"max-height":"900px"}
            }, null, 8, _hoisted_61)
          ]),
          _createVNode(_component_page_bottom)
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"])
  ], 64))
}